var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "user-setting-wrap jzbWrap",
      staticStyle: { display: "inline-block", "min-width": "800px" }
    },
    [
      _c(
        "el-card",
        [
          _vm.showHasbingContent
            ? _c("hasBinding", {
                attrs: { type: _vm.type, info: _vm.getData },
                on: { unbinding: _vm.unbindingHandler, gobind: _vm.pendingBind }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showBindingContentStep,
                  expression: "showBindingContentStep"
                }
              ]
            },
            [
              _c(
                "div",
                {
                  staticClass: "account-number",
                  attrs: { flex: "dir:left cross:center" }
                },
                [
                  _c("img", {
                    staticStyle: { "margin-right": "10px" },
                    attrs: { src: _vm.userIcon, alt: "img", width: "38" }
                  }),
                  _vm._v(" "),
                  _c("div", { attrs: { flex: "dir:top" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "fs-12 c-333",
                        staticStyle: { "margin-bottom": "5px" }
                      },
                      [_vm._v("子账户账号")]
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { flex: "dir:left cross:center" } }, [
                      _c("div", { staticClass: "fs-16 c-333 bold" }, [
                        _vm._v(_vm._s(_vm.jzbAccount))
                      ]),
                      _vm._v(" "),
                      _vm.isPendingStatus != 2
                        ? _c("div", { staticClass: "binding-no" }, [
                            _vm._v("未绑定")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isPendingStatus === 2
                        ? _c("div", { staticClass: "binding-yes" }, [
                            _vm._v("已绑定")
                          ])
                        : _vm._e()
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "bindingForm",
                  attrs: {
                    model: _vm.firstStepForm,
                    rules: _vm.rules,
                    "label-width": "120px",
                    inline: ""
                  }
                },
                [
                  _c("div", { staticClass: "box-info-fill" }, [
                    _c(
                      "div",
                      {
                        staticClass: "fs-16 c-333 m-b-16 bold",
                        staticStyle: { "padding-left": "40px" }
                      },
                      [_vm._v("银行信息")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "绑定类型" } },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: "",
                                value: _vm.type === 1 ? "企业" : "个人"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "银行类型", prop: "BankType" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择银行卡类型" },
                                model: {
                                  value: _vm.firstStepForm.BankType,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.firstStepForm,
                                      "BankType",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "firstStepForm.BankType"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "本行(平安银行)", value: 1 }
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "他行(非平安银行)", value: 2 }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "银行名称", prop: "bankHead" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  filterable: "",
                                  placeholder: "请选择银行",
                                  "value-key": "eiconBranchNo"
                                },
                                on: { change: _vm.checkBankHandler },
                                model: {
                                  value: _vm.firstStepForm.bankHead,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.firstStepForm,
                                      "bankHead",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "firstStepForm.bankHead"
                                }
                              },
                              _vm._l(_vm.branchNameList, function(item) {
                                return _c("el-option", {
                                  key: item.eiconBranchNo,
                                  attrs: { label: item.branchName, value: item }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "区域", prop: "bankRegion" } },
                          [
                            _c("el-cascader", {
                              attrs: {
                                clearable: "",
                                placeholder: "请选择区域",
                                options: _vm.provinceList,
                                props: _vm.regionProps
                              },
                              on: { change: _vm.checkBankRegion },
                              model: {
                                value: _vm.firstStepForm.bankRegion,
                                callback: function($$v) {
                                  _vm.$set(_vm.firstStepForm, "bankRegion", $$v)
                                },
                                expression: "firstStepForm.bankRegion"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "银行支行", prop: "bankChild" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  filterable: "",
                                  "no-data-text": "请先选择银行名称和区域",
                                  loading: _vm.acctOpenBranchNameListLoading,
                                  "value-key": "cnapsBranchNo",
                                  placeholder: _vm.firstStepForm.bankHead
                                    ? "请选择支行"
                                    : "请先选择银行"
                                },
                                model: {
                                  value: _vm.firstStepForm.bankChild,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.firstStepForm,
                                      "bankChild",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "firstStepForm.bankChild"
                                }
                              },
                              _vm._l(_vm.acctOpenBranchNameList, function(
                                item
                              ) {
                                return _c("el-option", {
                                  key: item.cnapsBranchNo,
                                  attrs: { label: item.branchName, value: item }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "银行卡号", prop: "bankCardNum" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入银行卡号" },
                              model: {
                                value: _vm.firstStepForm.bankCardNum,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.firstStepForm,
                                    "bankCardNum",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "firstStepForm.bankCardNum"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "手机号", prop: "Mobile" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入手机号" },
                              model: {
                                value: _vm.firstStepForm.Mobile,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.firstStepForm,
                                    "Mobile",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "firstStepForm.Mobile"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "info",
                                staticStyle: {
                                  display: "inline-block",
                                  "padding-left": "10px"
                                }
                              },
                              [
                                _c("i", { staticClass: "el-icon-warning" }),
                                _vm._v(
                                  "提示:请填写银行卡号绑定的手机号\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "box-info-fill" }, [
                    _c("div", { staticClass: "m-b-16" }, [
                      _c(
                        "span",
                        {
                          staticClass: "fs-16 c-333 bold",
                          staticStyle: { "padding-left": "40px" }
                        },
                        [_vm._v("商户信息")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "info",
                          staticStyle: {
                            display: "inline-block",
                            "padding-left": "10px"
                          }
                        },
                        [
                          _c("i", { staticClass: "el-icon-warning" }),
                          _vm._v(
                            "注意：商户信息一旦提交成功，无法再修改，请仔细核对\n            "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.type === 2
                      ? _c("div", [
                          _c(
                            "div",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "姓名", prop: "accountName" }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入姓名",
                                      disabled:
                                        _vm.hasDefaultVal || _vm.nameDisabled
                                    },
                                    model: {
                                      value: _vm.firstStepForm.accountName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.firstStepForm,
                                          "accountName",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "firstStepForm.accountName"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "个人证件类型",
                                    prop: "cardType"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        size: "mini",
                                        filterable: "",
                                        clearable: "",
                                        disabled: _vm.hasDefaultVal,
                                        placeholder: "请选择证件类型"
                                      },
                                      model: {
                                        value: _vm.firstStepForm.cardType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.firstStepForm,
                                            "cardType",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "firstStepForm.cardType"
                                      }
                                    },
                                    _vm._l(_vm.cardTypeList, function(item) {
                                      return _c("el-option", {
                                        key: item.cid,
                                        attrs: {
                                          label: item.name,
                                          value: item.cid
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "个人证件号码",
                                    prop: "cardNum"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入个人证件号码",
                                      disabled: _vm.hasDefaultVal
                                    },
                                    model: {
                                      value: _vm.firstStepForm.cardNum,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.firstStepForm,
                                          "cardNum",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "firstStepForm.cardNum"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "个体工商户",
                                    prop: "BusinessFlag"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择个体工商户",
                                        disabled: _vm.hasDefaultVal
                                      },
                                      model: {
                                        value: _vm.firstStepForm.BusinessFlag,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.firstStepForm,
                                            "BusinessFlag",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "firstStepForm.BusinessFlag"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "是", value: 1 }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.firstStepForm.BusinessFlag === 1
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "企业名称",
                                        prop: "companyName"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "请输入企业名称",
                                          disabled: _vm.hasDefaultVal
                                        },
                                        model: {
                                          value: _vm.firstStepForm.companyName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.firstStepForm,
                                              "companyName",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "firstStepForm.companyName"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "企业证件类型",
                                        prop: "companyGlobalType"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            size: "mini",
                                            filterable: "",
                                            clearable: "",
                                            disabled: _vm.hasDefaultVal,
                                            placeholder: "请选择证件类型"
                                          },
                                          model: {
                                            value:
                                              _vm.firstStepForm
                                                .companyGlobalType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.firstStepForm,
                                                "companyGlobalType",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "firstStepForm.companyGlobalType"
                                          }
                                        },
                                        _vm._l(_vm.cardTypeList, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.cid,
                                            attrs: {
                                              label: item.name,
                                              value: item.cid
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "企业证件号码",
                                        prop: "companyGlobalId"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "请输入企业证件号码",
                                          disabled: _vm.hasDefaultVal
                                        },
                                        model: {
                                          value:
                                            _vm.firstStepForm.companyGlobalId,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.firstStepForm,
                                              "companyGlobalId",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "firstStepForm.companyGlobalId"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.firstStepForm.BusinessFlag === 1
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.firstStepForm.accountName
                                          ? "法人" +
                                            _vm.firstStepForm.accountName
                                          : "法人",
                                        prop: "repFlag"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            placeholder: "是否为法人",
                                            disabled: _vm.hasDefaultVal
                                          },
                                          model: {
                                            value: _vm.firstStepForm.repFlag,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.firstStepForm,
                                                "repFlag",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "firstStepForm.repFlag"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: { label: "是", value: 1 }
                                          }),
                                          _vm._v(" "),
                                          _c("el-option", {
                                            attrs: { label: "否", value: 2 }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.firstStepForm.repFlag === 2 &&
                          _vm.firstStepForm.BusinessFlag === 1
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "法人姓名",
                                        prop: "reprName"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "请输入法人姓名",
                                          disabled: _vm.hasDefaultVal
                                        },
                                        model: {
                                          value: _vm.firstStepForm.reprName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.firstStepForm,
                                              "reprName",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "firstStepForm.reprName"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "法人证件类型",
                                        prop: "reprGlobalType"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            size: "mini",
                                            filterable: "",
                                            clearable: "",
                                            disabled: _vm.hasDefaultVal,
                                            placeholder: "请选择证件类型"
                                          },
                                          model: {
                                            value:
                                              _vm.firstStepForm.reprGlobalType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.firstStepForm,
                                                "reprGlobalType",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "firstStepForm.reprGlobalType"
                                          }
                                        },
                                        _vm._l(_vm.cardTypeList, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.cid,
                                            attrs: {
                                              label: item.name,
                                              value: item.cid
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "法人证件号码",
                                        prop: "reprGlobalId"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "请输入法人证件号码",
                                          disabled: _vm.hasDefaultVal
                                        },
                                        model: {
                                          value: _vm.firstStepForm.reprGlobalId,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.firstStepForm,
                                              "reprGlobalId",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "firstStepForm.reprGlobalId"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === 1
                      ? _c("div", [
                          _c(
                            "div",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "企业名称",
                                    prop: "accountName"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入企业名称",
                                      disabled:
                                        _vm.hasDefaultVal || _vm.nameDisabled
                                    },
                                    model: {
                                      value: _vm.firstStepForm.accountName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.firstStepForm,
                                          "accountName",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "firstStepForm.accountName"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "统一社会信用代码",
                                    prop: "cardNum",
                                    "label-width": "145px"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入统一社会信用代码",
                                      disabled: _vm.hasDefaultVal
                                    },
                                    model: {
                                      value: _vm.firstStepForm.cardNum,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.firstStepForm,
                                          "cardNum",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "firstStepForm.cardNum"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "法人姓名", prop: "reprName" }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入法人姓名",
                                      disabled: _vm.hasDefaultVal
                                    },
                                    model: {
                                      value: _vm.firstStepForm.reprName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.firstStepForm,
                                          "reprName",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "firstStepForm.reprName"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "法人证件类型",
                                    prop: "reprGlobalType"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        size: "mini",
                                        filterable: "",
                                        clearable: "",
                                        disabled: _vm.hasDefaultVal,
                                        placeholder: "请选择证件类型"
                                      },
                                      model: {
                                        value: _vm.firstStepForm.reprGlobalType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.firstStepForm,
                                            "reprGlobalType",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression:
                                          "firstStepForm.reprGlobalType"
                                      }
                                    },
                                    _vm._l(_vm.cardTypeList, function(item) {
                                      return _c("el-option", {
                                        key: item.cid,
                                        attrs: {
                                          label: item.name,
                                          value: item.cid
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "法人证件号码",
                                    prop: "reprGlobalId"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入法人证件号码",
                                      disabled: _vm.hasDefaultVal
                                    },
                                    model: {
                                      value: _vm.firstStepForm.reprGlobalId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.firstStepForm,
                                          "reprGlobalId",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "firstStepForm.reprGlobalId"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "存在经办人",
                                    prop: "agencyClientFlag"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "是否存在经办人",
                                        disabled: _vm.hasDefaultVal
                                      },
                                      model: {
                                        value:
                                          _vm.firstStepForm.agencyClientFlag,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.firstStepForm,
                                            "agencyClientFlag",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression:
                                          "firstStepForm.agencyClientFlag"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "是", value: 1 }
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "否", value: 2 }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.firstStepForm.agencyClientFlag === 1
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "经办人姓名",
                                        prop: "agencyClientName"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "请输入经办人姓名",
                                          disabled: _vm.hasDefaultVal
                                        },
                                        model: {
                                          value:
                                            _vm.firstStepForm.agencyClientName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.firstStepForm,
                                              "agencyClientName",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "firstStepForm.agencyClientName"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "经办人证件类型",
                                        prop: "agencyClientGlobalType"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            size: "mini",
                                            filterable: "",
                                            clearable: "",
                                            disabled: _vm.hasDefaultVal,
                                            placeholder: "经办人证件类型"
                                          },
                                          model: {
                                            value:
                                              _vm.firstStepForm
                                                .agencyClientGlobalType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.firstStepForm,
                                                "agencyClientGlobalType",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "firstStepForm.agencyClientGlobalType"
                                          }
                                        },
                                        _vm._l(_vm.cardTypeList, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.cid,
                                            attrs: {
                                              label: item.name,
                                              value: item.cid
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "经办人证件号",
                                        prop: "agencyClientGlobalId"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "请输入经办人证件号",
                                          disabled: _vm.hasDefaultVal
                                        },
                                        model: {
                                          value:
                                            _vm.firstStepForm
                                              .agencyClientGlobalId,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.firstStepForm,
                                              "agencyClientGlobalId",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "firstStepForm.agencyClientGlobalId"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "经办人手机号",
                                        prop: "agencyClientMobile"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "请输入经办人手机号",
                                          disabled: _vm.hasDefaultVal
                                        },
                                        model: {
                                          value:
                                            _vm.firstStepForm
                                              .agencyClientMobile,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.firstStepForm,
                                              "agencyClientMobile",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "firstStepForm.agencyClientMobile"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: { padding: "20px 0" },
                      attrs: { flex: "main:center cross:center" }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.agreement,
                            callback: function($$v) {
                              _vm.agreement = $$v
                            },
                            expression: "agreement"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "#555555"
                              }
                            },
                            [_vm._v("已阅读并同意")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://br.pingan.com/ttest",
                                target: "_blank"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    color: "#FF6224",
                                    cursor: "pointer"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                《平安银行电子商务支付结算服务协议》\n              "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "https://auth.orangebank.com.cn/#/m/cDealOne?pageConf=1_0_0",
                                target: "_blank"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    color: "#FF6224",
                                    cursor: "pointer"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                《数字口袋协议》\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.nextCardShow,
                  expression: "nextCardShow"
                }
              ],
              staticClass: "setting-next-card",
              staticStyle: { position: "relative" }
            },
            [
              _c(
                "el-form",
                {
                  ref: "nextForm",
                  attrs: {
                    model: _vm.endStepForm,
                    rules: _vm.rules,
                    "label-width": "100px",
                    inline: ""
                  }
                },
                [
                  _c(
                    "span",
                    {
                      class: {
                        "card-type-icon-person": _vm.bindType === "个人",
                        "card-type-icon-bus": _vm.bindType === "企业"
                      }
                    },
                    [_vm._v(_vm._s(_vm.bindType))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("el-form-item", { attrs: { label: "银行名称" } }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#606266",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("bankname")(_vm.firstStepForm.bankHead)
                              )
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "银行卡号" } }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#606266",
                              "font-size": "12px"
                            }
                          },
                          [_vm._v(_vm._s(_vm.firstStepForm.bankCardNum))]
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  (_vm.bindType === "个人"
                  ? true
                  : false)
                    ? [
                        _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "手机号" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入手机号",
                                    disabled: true
                                  },
                                  model: {
                                    value: _vm.firstStepForm.Mobile,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.firstStepForm,
                                        "Mobile",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "firstStepForm.Mobile"
                                  }
                                }),
                                _vm._v(" "),
                                !_vm.showTimer
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini"
                                        },
                                        on: { click: _vm.sendMobileCode }
                                      },
                                      [_vm._v(_vm._s(_vm.sendMobileCodeText))]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showTimer
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary", size: "mini" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.timer) + "s后重新发送"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "鉴权金额", prop: "amount" } },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: { placeholder: "请输入鉴权金额" },
                                    model: {
                                      value: _vm.endStepForm.amount,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.endStepForm,
                                          "amount",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "endStepForm.amount"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "iconfont icon-qian",
                                      staticStyle: { "font-size": "12px" },
                                      attrs: { slot: "prefix" },
                                      slot: "prefix"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "info" }, [
                                  _c("i", { staticClass: "el-icon-warning" }),
                                  _vm._v(
                                    "提示：请查询银行卡转账结果。若成功，请填写绑定银行账户收到的鉴权金额。\n              "
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "验证码", prop: "msgCode" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入验证码" },
                                  model: {
                                    value: _vm.endStepForm.msgCode,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.endStepForm,
                                        "msgCode",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "endStepForm.msgCode"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.bindType === "企业"
                  ? true
                  : false)
                    ? [
                        _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "手机号" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入手机号",
                                    disabled: true
                                  },
                                  model: {
                                    value: _vm.firstStepForm.Mobile,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.firstStepForm,
                                        "Mobile",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "firstStepForm.Mobile"
                                  }
                                }),
                                _vm._v(" "),
                                !_vm.showTimer
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini"
                                        },
                                        on: { click: _vm.sendMobileCode }
                                      },
                                      [_vm._v("发送验证金额")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showTimer
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary", size: "mini" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.timer) + "s后重新发送"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "鉴权金额", prop: "amount" } },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: { placeholder: "请输入鉴权金额" },
                                    model: {
                                      value: _vm.endStepForm.amount,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.endStepForm,
                                          "amount",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "endStepForm.amount"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "iconfont icon-qian",
                                      staticStyle: { "font-size": "12px" },
                                      attrs: { slot: "prefix" },
                                      slot: "prefix"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "info" }, [
                                  _c("i", { staticClass: "el-icon-warning" }),
                                  _vm._v(
                                    "提示：请查询银行卡转账结果。若成功，请填写绑定银行账户收到的鉴权金额。\n              "
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "验证码", prop: "msgCode" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入验证码" },
                                  model: {
                                    value: _vm.endStepForm.msgCode,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.endStepForm,
                                        "msgCode",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "endStepForm.msgCode"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("el-form-item", { attrs: { label: "币种" } }, [
                              _c("span", { style: { "font-size": "12px" } }, [
                                _vm._v("人民币")
                              ])
                            ])
                          ],
                          1
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showBindingContentStep,
                  expression: "showBindingContentStep"
                }
              ],
              staticClass: "submitBtnWrap"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      return _vm.nextCardHandler(true, "bindingForm")
                    }
                  }
                },
                [_vm._v("下一步")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.nextCardShow,
                  expression: "nextCardShow"
                }
              ],
              staticClass: "submitBtnWrap"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      return _vm.nextCardHandler(false, "nextForm")
                    }
                  }
                },
                [_vm._v("上一步")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.submitForm("nextForm")
                    }
                  }
                },
                [_vm._v("提交")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "信息认证",
            "modal-append-to-body": false,
            center: "",
            visible: _vm.dialogVisible,
            top: "250px",
            width: "400px",
            "show-close": false,
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "jzbWrap exportbtnbox" }, [
            _c("div", { staticClass: "text-center" }, [
              _vm._v("平安银行为加强商户安全信息管理，需要重新补充认证信息")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { color: "#ff6224", "margin-top": "10px" } },
              [_vm._v("步骤")]
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { color: "#ff6224" } }, [
              _vm._v("1.点击“立即认证”前往平安银行页面认证信息")
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { color: "#ff6224" } }, [
              _vm._v("2.认证完成后点击“我已认证”")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "add-margin" },
              [
                _c(
                  "el-button",
                  { attrs: { type: "text" }, on: { click: _vm.initData } },
                  [_vm._v("我已认证")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "button-bg-color",
                    attrs: { type: "primary" },
                    on: { click: _vm.navToAuthenticationUrl }
                  },
                  [_vm._v("立即认证")]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0497a50c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0497a50c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/userBinding.vue
// module id = null
// module chunks = 